import { isEmpty } from "lodash";
import { useBoundStore } from "store";
import { useMyPermissions } from "users/queries";

export const useHasPermissions = () => {
  const { currentOrganization } = useBoundStore();
  const { data: permissionsData, isPending } = useMyPermissions(currentOrganization?.id);

  const hasPermissions = (permissionsNeeded: string[]) => {
    if (isEmpty(permissionsNeeded)) {
      return true;
    }

    if (isPending || !permissionsData?.permissions) {
      return false;
    }

    const userPermissions = new Set(permissionsData.permissions);
    return permissionsNeeded.every((permission) => userPermissions.has(permission));
  };

  const hasAnyPermission = (permissionsNeeded: string[]) => {
    if (isEmpty(permissionsNeeded)) {
      return true;
    }

    if (isPending || !permissionsData?.permissions) {
      return false;
    }

    const userPermissions = new Set(permissionsData.permissions);
    return permissionsNeeded.some((permission) => userPermissions.has(permission));
  };

  return {
    hasPermissions,
    hasAnyPermission,
    permissions: permissionsData?.permissions ?? [],
    role: permissionsData?.role,
    isLoading: isPending,
  };
};
